import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Avatar, Box, Divider, IconButton, ListItemIcon, Menu, MenuItem, Tooltip, Typography } from '@mui/material';
import { IconLogout, IconSettings } from '@tabler/icons-react';
import useLogin from 'hooks/useLogin';
export default function ProfileSection() {
  const user = useSelector((state) => state.account.user);
  const [anchor, setAnchor] = useState(null);
  const [busy, setBusy] = useState(false);
  const { logout } = useLogin();
  const name = user?.display_name || user?.username || '账户';
  return (
    <>
      <Tooltip title="账户菜单">
        <IconButton
          aria-label="账户菜单"
          aria-haspopup="menu"
          aria-expanded={!!anchor}
          aria-controls={anchor ? 'account-menu' : undefined}
          onClick={(event) => setAnchor(event.currentTarget)}
          sx={{ p: 0.5 }}
        >
          <Avatar sx={{ width: 34, height: 34, bgcolor: 'primary.light', color: 'primary.dark', fontSize: 14, fontWeight: 600 }}>
            {name.slice(0, 1).toUpperCase()}
          </Avatar>
        </IconButton>
      </Tooltip>
      <Menu
        id="account-menu"
        anchorEl={anchor}
        open={!!anchor}
        onClose={() => setAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: { minWidth: 220, mt: 1, border: '1px solid', borderColor: 'divider', boxShadow: '0 8px 30px rgba(20,24,40,.1)' }
        }}
      >
        <Box sx={{ px: 2, py: 1.5 }}>
          <Typography fontWeight={600}>{name}</Typography>
          <Typography variant="caption" color="text.secondary">
            个人工作空间
          </Typography>
        </Box>
        <Divider />
        <MenuItem component={Link} to="/panel/profile" onClick={() => setAnchor(null)}>
          <ListItemIcon>
            <IconSettings size={19} />
          </ListItemIcon>
          账户设置
        </MenuItem>
        <MenuItem
          disabled={busy}
          onClick={async () => {
            setBusy(true);
            try {
              await logout();
              setAnchor(null);
            } finally {
              setBusy(false);
            }
          }}
        >
          <ListItemIcon>
            <IconLogout size={19} />
          </ListItemIcon>
          {busy ? '正在退出…' : '退出登录'}
        </MenuItem>
      </Menu>
    </>
  );
}
